import { render, staticRenderFns } from "./GiftPatron.vue?vue&type=template&id=1ae09aa7&scoped=true&"
import script from "./GiftPatron.vue?vue&type=script&lang=js&"
export * from "./GiftPatron.vue?vue&type=script&lang=js&"
import style0 from "./GiftPatron.vue?vue&type=style&index=0&id=1ae09aa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae09aa7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MtInput: require('/home/bitrix/frontend/components/form/MtInput.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
